export const DOMAINS = {
  partnerbrite: 'partnerbrite',
  crowdcatch: 'crowdcatch'
}

export const countriesList = [
  {
    value: 'GB',
    label: 'United Kingdom'
  },
  {
    value: 'IE',
    label: 'Ireland'
  }
]
